import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { connect } from 'react-redux';
import Search from '../components/Search';
import Bracket from '../components/Bracket';
import { BASE_SPACING } from '../styles';
import Wrapper from '../components/Wrapper';
import Button, { TYPES } from '../components/Button';
import {
  getBrackets,
  openConfirm,
  deleteBracket,
  fetchBrackets,
} from '../redux/app';
import Link from '../components/Link';
import debounce from 'lodash/debounce';
import { BASENAME, BUNDLE_URL, XC_URL } from '../config';
import copy from 'copy-to-clipboard';

const s = StyleSheet.create({
  bracketListWrapper: {
    padding: `${BASE_SPACING}px ${BASE_SPACING}px`,
  },
  addNewWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: 10,
  },
});

class BracketList extends React.Component {
  state = {
    search: this.props.brackets.keyword,
  };

  deleteBracket = (id) => (close) => {
    this.props.deleteBracket(id);
    close();
  };

  onDelete =
    ({ title, id }) =>
    () => {
      this.props.openConfirm({
        title: {
          messageId: 'app.delete.bracket.title',
        },
        message: {
          messageId: 'app.delete.bracket.message',
          variables: {
            bracket: `<strong>${title}</strong>`,
          },
        },
        buttons: [
          {
            messageId: 'app.discard.changes.button',
            onClick: this.deleteBracket(id),
          },
        ],
      });
    };

  copyBracket =
    ({ id, title }) =>
    () => {
      const config = {
        scriptURL: `${BUNDLE_URL}?id=${id}`,
        scriptConfig: {
          id,
        },
      };

      copy(JSON.stringify(config, null, 2));

      this.props.openConfirm({
        title: {
          messageId: 'app.bracket.config.copy.title',
        },
        message: {
          messageId: 'app.bracket.config.copy.message',
          variables: {
            bracket: `<strong>${title}</strong>'s`,
            xc: XC_URL,
          },
        },
        cancel: 'app.bracket.config.copy.close',
      });
    };

  refreshList = debounce(() => {
    this.props.fetchBrackets(this.state.search);
  }, 200);

  search = (e) => {
    this.setState(
      {
        search: e.target.value,
      },
      this.refreshList
    );
  };

  render() {
    return (
      <>
        <Search onChange={this.search} value={this.state.search} />
        <Wrapper __className={s.bracketListWrapper}>
          <div className={css(s.addNewWrapper)}>
            <Button
              messageId="app.create.bracket"
              iconName="plus"
              __type={TYPES.TRANSPARENT}
              component={Link}
              to={BASENAME + '/tree/create'}
            />
          </div>
          {this.props.brackets.items.map((bracket) => (
            <Bracket
              {...bracket}
              key={bracket.id}
              onDelete={this.onDelete(bracket)}
              onCopy={this.copyBracket(bracket)}
            />
          ))}
        </Wrapper>
      </>
    );
  }
}

BracketList.propTypes = {
  brackets: PropTypes.object,
  openConfirm: PropTypes.func,
  fetchBrackets: PropTypes.func,
  deleteBracket: PropTypes.func,
};

const mapStateToProps = (state) => ({
  brackets: getBrackets(state),
});

const mapDispatchToProps = (dispatch) => ({
  openConfirm: (props) => dispatch(openConfirm(props)),
  deleteBracket: (id) => dispatch(deleteBracket(id)),
  fetchBrackets: (keyword) => dispatch(fetchBrackets(keyword)),
  fetchTreeConfig: (keyword) => dispatch(fetchBrackets(keyword)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BracketList);
